import { render } from "./FilterReviewsByStar.vue?vue&type=template&id=9a080634&scoped=true"
import script from "./FilterReviewsByStar.vue?vue&type=script&lang=js"
export * from "./FilterReviewsByStar.vue?vue&type=script&lang=js"

import "./FilterReviewsByStar.vue?vue&type=style&index=0&id=9a080634&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a080634"]])

export default __exports__